// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"FilterSidebar_sidebar__1ialy"};